var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center display-1 text-light py-5"},[_vm._v(" 404 "),_c('br'),_vm._v(" not found ")])}]

export { render, staticRenderFns }